/*
  VIOLA — Sunglasses auto-switcher
  All frames are already rendered eagerly in the HTML (see
  sections/sunglasses-switcher.liquid), so by the time this runs every
  image is already requested/decoding — this script only ever toggles the
  `.is-active` class, it never swaps `src` or fetches anything, so there is
  no flash/loading delay at any switch. Lightweight: one setInterval per
  section instance, paused while the tab is hidden so it isn't doing work
  (or restarting mid-cycle awkwardly) in a background tab.
*/
(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initSwitcher(root) {
    var images = Array.prototype.slice.call(root.querySelectorAll(".sunglasses-switcher__img"));
    if (images.length < 2) return; // nothing to switch between

    var interval = parseInt(root.getAttribute("data-interval"), 10);
    if (!interval || isNaN(interval)) interval = 3000;
    // Reduced motion: still rotate the frames (it's real content, not just
    // decoration) but at a calmer pace, matching the instant-crossfade CSS.
    if (prefersReducedMotion) interval = Math.max(interval, 3500);

    var current = images.findIndex(function (img) {
      return img.classList.contains("is-active");
    });
    if (current === -1) current = 0;

    var timer = null;

    function advance() {
      var next = (current + 1) % images.length;
      images[current].classList.remove("is-active");
      images[next].classList.add("is-active");
      current = next;
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(advance, interval);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    start();

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });
  }

  function init() {
    var roots = document.querySelectorAll("[data-sunglasses-switcher]");
    for (var i = 0; i < roots.length; i++) {
      initSwitcher(roots[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Theme editor: re-init a freshly-added/re-rendered section instance.
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-sunglasses-switcher]");
    if (root) initSwitcher(root);
  });
})();
